import { ComingSoon } from "components/commons";

function Upload() {
  return (
    <div className="flex-1 flex flex-col justify-center items-center">
      <ComingSoon
        type="camera"
        des="Posting Your Exclusive Content for Shareholders:"
      />
    </div>
  );
}

export { Upload as default };
